import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { ReferralTemplateBase } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class TemplatesHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public loadTemplates(): Observable<ReferralTemplateBase[]> {
    return this.httpApi
      .get(`/referral/templates`)
      .pipe(map(response => response.referralTemplates));
  }

  public updateTemplatePositions(positions: number[]): Observable<any> {
    return this.httpApi.patch(`/referral/templates/update_positions`, null, {
      referral_templates: positions,
    });
  }
}
